import { create } from "zustand";

type Options = { [k: string]: { title?: string } | undefined };

interface OptionsMapState {
  options: Options;
}

export const useNavigationTitleHistory = create<OptionsMapState>((set) => ({
  options: {},
}));

export const useNavigationTitleHistoryActions = () => {
  return {
    set: (opts: Options) =>
      useNavigationTitleHistory.setState((state) => ({
        options: { ...state.options, ...opts },
      })),
    delete: (key: string) =>
      useNavigationTitleHistory.setState((state) => {
        const newOpts = state.options;
        delete newOpts[key];

        return { options: newOpts };
      }),
  };
};
